// Analytics page constants

export const MODEL_KEYS = ['H1_MFE_ML', 'GASBERT', 'USOII', 'LOI', 'GOI', 'SILVIO', 'RUS', 'QUINI', 'LIBRA', 'COOP', 'YENI', 'DUS', 'MANUAL'] as const;

export const MODEL_DISPLAY_NAMES: Record<string, string> = {
  'GASBERT_DualEvent_Hybrid_v0': 'GASBERT',
  'USOII_GlobalEvent_Classifier_v0': 'USOII',
  'LOI_GlobalEvent_Classifier_v0': 'LOI',
  'GOI_GlobalEvent_Classifier_v0': 'GOI',
  'SILVIO_GlobalEvent_Classifier_v0': 'SILVIO',
  'RUS_GlobalEvent_Classifier_v0': 'RUS',
  'QUINI_GlobalEvent_Classifier_v0': 'QUINI',
  'LIBRA_GlobalEvent_Classifier_v0': 'LIBRA',
  'COOP_GlobalEvent_Classifier_v0': 'COOP',
  'YENI_GlobalEvent_Classifier_v0': 'YENI',
  'DUS_GlobalEvent_Classifier_v0': 'DUS',
  'HOUR_MFE_ML': 'H1 MFE ML',
};

export const MODEL_LABELS: Record<string, string> = {
  'H1_MFE_ML': 'H1 MFE ML',
  'GASBERT': 'GASBERT',
  'USOII': 'USOII',
  'LOI': 'LOI',
  'GOI': 'GOI',
  'SILVIO': 'SILVIO',
  'RUS': 'RUS',
  'QUINI': 'QUINI',
  'LIBRA': 'LIBRA',
  'COOP': 'COOP',
  'YENI': 'YENI',
  'DUS': 'DUS',
  'MANUAL': 'MANUAL',
};

export const MANUAL_ACCOUNT_ID = '299087495130306062';
export const UNIFIED_ACCOUNT_ID = '299082010457069070';
